import { safeLocalStorage } from "@helpers/storage"

const QUIZ_ANSWERS_STORAGE_KEY = "vm_quiz_answers"

type QuizAnswers = Record<string, string[]>

export function getQuizAnswers(): QuizAnswers {
  try {
    const raw = safeLocalStorage.getItem(QUIZ_ANSWERS_STORAGE_KEY)

    return raw ? (JSON.parse(raw) as QuizAnswers) : {}
  } catch {
    return {}
  }
}

export function setQuizAnswer(stepId: string, answer: string[]) {
  const answers = { ...getQuizAnswers(), [stepId]: answer }

  // NOTE: With storage blocked, kept in memory: the personalisation lasts
  // for this page load.
  safeLocalStorage.setItem(QUIZ_ANSWERS_STORAGE_KEY, JSON.stringify(answers))
}
